const $673cc00792cdcb0b$var$ATTRIBUTE = "data-highlight";
const $673cc00792cdcb0b$var$SELECTOR = `[${$673cc00792cdcb0b$var$ATTRIBUTE}]`;
function $673cc00792cdcb0b$export$445db1dad3224ad0(document) {
    const elements = document.querySelectorAll($673cc00792cdcb0b$var$SELECTOR);
    const observer = new IntersectionObserver($673cc00792cdcb0b$var$handler);
    elements.forEach((element)=>observer.observe(element));
}
function $673cc00792cdcb0b$var$getValues(target) {
    return target.getAttribute($673cc00792cdcb0b$var$ATTRIBUTE).split(" ");
}
function $673cc00792cdcb0b$var$addClasses(target) {
    target.classList.add(...$673cc00792cdcb0b$var$getValues(target));
}
function $673cc00792cdcb0b$var$removeClasses(target) {
    target.classList.remove(...$673cc00792cdcb0b$var$getValues(target));
}
function $673cc00792cdcb0b$var$handler(entries) {
    entries.forEach($673cc00792cdcb0b$var$handleEntry);
}
function $673cc00792cdcb0b$var$handleEntry(entry) {
    if (entry.isIntersecting) $673cc00792cdcb0b$var$addClasses(entry.target);
    else $673cc00792cdcb0b$var$removeClasses(entry.target);
}


var $8166abee130598eb$var$t = function() {
    return $8166abee130598eb$var$t = Object.assign || function(t) {
        for(var i, e = 1, s = arguments.length; e < s; e++)for(var n in i = arguments[e])Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
        return t;
    }, $8166abee130598eb$var$t.apply(this, arguments);
}, $8166abee130598eb$export$1567cc001e3d0c1d = function() {
    function i(i, e, s) {
        var n = this;
        this.endVal = e, this.options = s, this.version = "2.10.0", this.defaults = {
            startVal: 0,
            decimalPlaces: 0,
            duration: 2,
            useEasing: !0,
            useGrouping: !0,
            useIndianSeparators: !1,
            smartEasingThreshold: 999,
            smartEasingAmount: 333,
            separator: ",",
            decimal: ".",
            prefix: "",
            suffix: "",
            autoAnimate: !1,
            autoAnimateDelay: 200,
            autoAnimateOnce: !1
        }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(t) {
            n.startTime || (n.startTime = t);
            var i = t - n.startTime;
            n.remaining = n.duration - i, n.useEasing ? n.countDown ? n.frameVal = n.startVal - n.easingFn(i, 0, n.startVal - n.endVal, n.duration) : n.frameVal = n.easingFn(i, n.startVal, n.endVal - n.startVal, n.duration) : n.frameVal = n.startVal + (n.endVal - n.startVal) * (i / n.duration);
            var e = n.countDown ? n.frameVal < n.endVal : n.frameVal > n.endVal;
            n.frameVal = e ? n.endVal : n.frameVal, n.frameVal = Number(n.frameVal.toFixed(n.options.decimalPlaces)), n.printValue(n.frameVal), i < n.duration ? n.rAF = requestAnimationFrame(n.count) : null !== n.finalEndVal ? n.update(n.finalEndVal) : n.options.onCompleteCallback && n.options.onCompleteCallback();
        }, this.formatNumber = function(t) {
            var i, e, s, a, o = t < 0 ? "-" : "";
            i = Math.abs(t).toFixed(n.options.decimalPlaces);
            var r = (i += "").split(".");
            if (e = r[0], s = r.length > 1 ? n.options.decimal + r[1] : "", n.options.useGrouping) {
                a = "";
                for(var l = 3, u = 0, h = 0, p = e.length; h < p; ++h)n.options.useIndianSeparators && 4 === h && (l = 2, u = 1), 0 !== h && u % l == 0 && (a = n.options.separator + a), u++, a = e[p - h - 1] + a;
                e = a;
            }
            return n.options.numerals && n.options.numerals.length && (e = e.replace(/[0-9]/g, function(t) {
                return n.options.numerals[+t];
            }), s = s.replace(/[0-9]/g, function(t) {
                return n.options.numerals[+t];
            })), o + n.options.prefix + e + s + n.options.suffix;
        }, this.easeOutExpo = function(t, i, e, s) {
            return e * (1 - Math.pow(2, -10 * t / s)) * 1024 / 1023 + i;
        }, this.options = $8166abee130598eb$var$t($8166abee130598eb$var$t({}, this.defaults), s), this.options.enableScrollSpy && (this.options.autoAnimate = !0), void 0 !== this.options.scrollSpyDelay && (this.options.autoAnimateDelay = this.options.scrollSpyDelay), this.options.scrollSpyOnce && (this.options.autoAnimateOnce = !0), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.el = "string" == typeof i ? document.getElementById(i) : i, e = null == e ? this.parse(this.el.innerHTML) : e, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(e), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, "" === this.options.separator && (this.options.useGrouping = !1), this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", "undefined" != typeof window && this.options.autoAnimate && (this.error || "undefined" == typeof IntersectionObserver ? this.error ? console.error(this.error, i) : console.error("IntersectionObserver is not supported by this browser") : this.setupObserver());
    }
    return i.prototype.setupObserver = function() {
        var t = this, e = i.observedElements.get(this.el);
        e && e.unobserve(), i.observedElements.set(this.el, this), this.observer = new IntersectionObserver(function(i) {
            for(var e = 0, s = i; e < s.length; e++){
                var n = s[e];
                n.isIntersecting && t.paused && !t.once ? (t.paused = !1, t.autoAnimateTimeout = setTimeout(function() {
                    return t.start();
                }, t.options.autoAnimateDelay), t.options.autoAnimateOnce && (t.once = !0, t.observer.disconnect())) : n.isIntersecting || t.paused || (clearTimeout(t.autoAnimateTimeout), t.reset());
            }
        }, {
            threshold: 0
        }), this.observer.observe(this.el);
    }, i.prototype.unobserve = function() {
        var t;
        clearTimeout(this.autoAnimateTimeout), null === (t = this.observer) || void 0 === t || t.disconnect(), i.observedElements.delete(this.el);
    }, i.prototype.onDestroy = function() {
        clearTimeout(this.autoAnimateTimeout), cancelAnimationFrame(this.rAF), this.paused = !0, this.unobserve(), this.options.onCompleteCallback = null, this.options.onStartCallback = null;
    }, i.prototype.determineDirectionAndSmartEasing = function() {
        var t = this.finalEndVal ? this.finalEndVal : this.endVal;
        this.countDown = this.startVal > t;
        var i = t - this.startVal;
        if (Math.abs(i) > this.options.smartEasingThreshold && this.options.useEasing) {
            this.finalEndVal = t;
            var e = this.countDown ? 1 : -1;
            this.endVal = t + e * this.options.smartEasingAmount, this.duration = this.duration / 2;
        } else this.endVal = t, this.finalEndVal = null;
        null !== this.finalEndVal ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
    }, i.prototype.start = function(t) {
        this.error || (this.options.onStartCallback && this.options.onStartCallback(), t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
    }, i.prototype.pauseResume = function() {
        this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
    }, i.prototype.reset = function() {
        clearTimeout(this.autoAnimateTimeout), cancelAnimationFrame(this.rAF), this.paused = !0, this.once = !1, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
    }, i.prototype.update = function(t) {
        cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, null == this.finalEndVal && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
    }, i.prototype.printValue = function(t) {
        var i;
        if (this.el) {
            var e = this.formattingFn(t);
            if (null === (i = this.options.plugin) || void 0 === i ? void 0 : i.render) this.options.plugin.render(this.el, e);
            else if ("INPUT" === this.el.tagName) this.el.value = e;
            else "text" === this.el.tagName || "tspan" === this.el.tagName ? this.el.textContent = e : this.el.innerHTML = e;
        }
    }, i.prototype.ensureNumber = function(t) {
        return "number" == typeof t && !isNaN(t);
    }, i.prototype.validateValue = function(t) {
        var i = Number(t);
        return this.ensureNumber(i) ? i : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
    }, i.prototype.resetDuration = function() {
        this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
    }, i.prototype.parse = function(t) {
        var i = function(t) {
            return t.replace(/([.,'  ])/g, "\\$1");
        }, e = i(this.options.separator), s = i(this.options.decimal), n = t.replace(new RegExp(e, "g"), "").replace(new RegExp(s, "g"), ".");
        return parseFloat(n);
    }, i.observedElements = new WeakMap, i;
}();


const $140f31e25841bd93$var$ATTRIBUTE = "data-countup";
const $140f31e25841bd93$var$SELECTOR = `[${$140f31e25841bd93$var$ATTRIBUTE}]`;
function $140f31e25841bd93$export$9732bca3c4e8bf5a(document) {
    const elements = document.querySelectorAll($140f31e25841bd93$var$SELECTOR);
    const options = {
        autoAnimate: true,
        separator: ".",
        decimal: ","
    };
    elements.forEach((element)=>{
        new (0, $8166abee130598eb$export$1567cc001e3d0c1d)(element, element.getAttribute($140f31e25841bd93$var$ATTRIBUTE), options);
    });
}


function $d2247bac48b6a171$export$653023c4fd90fd41(options) {
    const handle = async (event)=>{
        event.preventDefault();
        options.form.classList.remove('failed');
        options.form.classList.add('sending');
        event.submitter.disabled = true;
        let res;
        try {
            res = await fetch(options.sendTo, {
                method: 'POST',
                body: new FormData(options.form)
            });
        } catch (error) {
            event.submitter.disabled = false;
            options.form.classList.replace('sending', 'failed');
            return;
        }
        if (!res.ok) {
            event.submitter.disabled = false;
            options.form.classList.replace('sending', 'failed');
            return;
        }
        setTimeout(()=>{
            options.form.reset();
            document.location.href = options.redirectTo;
        }, 1000);
    };
    options.form.addEventListener('submit', handle);
}


const $b40a7503a71fab31$var$UTM = [
    {
        param: "utm_source",
        key: "utmSource"
    },
    {
        param: "utm_medium",
        key: "utmMedium"
    },
    {
        param: "utm_campaign",
        key: "utmCampaign"
    },
    {
        param: "utm_term",
        key: "utmTerm"
    },
    {
        param: "utm_content",
        key: "utmContent"
    }
];
function $b40a7503a71fab31$export$bf2f09637ac91973(options) {
    const urlParams = new URLSearchParams(window.location.search);
    const urlUtm = {};
    $b40a7503a71fab31$var$UTM.map((item)=>[
            item.param,
            item.key
        ]).forEach(([param, key])=>{
        if (!urlParams.has(param)) return;
        urlUtm[key] = urlParams.get(param);
    });
    const urlHasUtm = Object.keys(urlUtm).length > 0;
    if (urlHasUtm) sessionStorage.setItem("utm", JSON.stringify(urlUtm));
    const utm = JSON.parse(sessionStorage.getItem("utm"));
    if (!utm) return;
    document.addEventListener("DOMContentLoaded", ()=>{
        $b40a7503a71fab31$var$UTM.map((item)=>item.key).forEach((key)=>{
            if (!(key in utm)) return;
            const field = document.createElement("input");
            field.type = "hidden";
            field.name = key;
            field.value = utm[key];
            options.form.prepend(field);
        });
    });
}


(0, $673cc00792cdcb0b$export$445db1dad3224ad0)(document);
(0, $140f31e25841bd93$export$9732bca3c4e8bf5a)(document);
document.addEventListener("DOMContentLoaded", (e)=>{
    document.querySelectorAll("a[href^=\"#\"]").forEach((anchor)=>{
        anchor.addEventListener("click", (e)=>{
            e.preventDefault();
            document.querySelector(e.target.getAttribute("href")).scrollIntoView({
                behavior: "smooth"
            });
        });
    });
});
(0, $b40a7503a71fab31$export$bf2f09637ac91973)({
    form: document.querySelector('#orcamento form')
});
(0, $d2247bac48b6a171$export$653023c4fd90fd41)({
    form: document.querySelector('#orcamento form'),
    sendTo: 'https://crm.desbrave.com.br/api/v1/accounts/gpool/leads',
    redirectTo: '/sucesso.html'
});


//# sourceMappingURL=repo.db265d7f.js.map
